import PrivacyStatement from './PrivacyStatementComponent'

export default PrivacyStatement
